export const validate = (inputs) => {

    const errors = {};


    if (inputs.titleFontSize) {
        var pattern = /^\d+$/;
        if (!pattern.test(inputs.titleFontSize)) {
            errors.titleFontSize = "Required only digit";
        }
    }

    if (inputs.descriptionFontSize) {
        var pattern = /^\d+$/;
        if (!pattern.test(inputs.descriptionFontSize)) {
            errors.descriptionFontSize = "Required only digit";
        }
    }


    return errors;
}